import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FirmwareInfo } from '../../model/firmware-info';
import { SoundbankFlasherComponent } from './soundbank-flasher.component';

@Injectable({
  providedIn: 'root'
})
export class SoundbankFlasherService {

  constructor(
    public modalService: NgbModal) { }

  get isFlasherOpen() : boolean {
    return (this._modalRef != undefined);
  }

  private _modalRef? : NgbModalRef = undefined;
  
  async openFlasher(firmwares: FirmwareInfo[]) : Promise<SoundbankFlasherComponent> {

    if (!this._modalRef) {

      this._modalRef = this.modalService.open(SoundbankFlasherComponent, { centered: true, size: 'xl', backdrop  : 'static', container: "#fullscreenContainer"  });
      let instance = <SoundbankFlasherComponent>this._modalRef.componentInstance;

      instance.closeCallback = this.closeFlasher.bind(this);
      instance.availableFirmwares = firmwares;
      instance.prepare();
      
      this._modalRef.result.then(
        () => { 
          this._modalRef = undefined; 
        }, 
        () => { 
          this._modalRef = undefined; 
        });

      return instance;
    }

    throw Error("SoundbankFlasher-Modal is already open.");
  }  

  async closeFlasher() {
    if (this._modalRef) {
      this._modalRef.close();
      this._modalRef = undefined;
    }
  }


}
